const { head, isSet } = require('lodash');

require('./bootstrap');





    const imgElement = document.querySelector("img")
  // const  test = imgElement.hasAttribute('data')
  if(imgElement && imgElement.hasAttribute('data-fancybox')){
    Fancybox.bind("[data-fancybox]", {
      // Your options go here
    });
  }
  
  let headerHeight = $("header").height();
  console.log(headerHeight)
  let navHeight = $("nav").outerHeight();
  console.log(navHeight)
  let footerHeight = $("footer").outerHeight(true);
  console.log(footerHeight)
  
  let sumHeight = headerHeight + navHeight + footerHeight;
  console.log(sumHeight)
  let finalHeight = $(window).innerHeight() - sumHeight
  console.log(finalHeight)
  
  $(".main--page--content").css("min-height", `${finalHeight}px`);

  if (typeof finalHeight !== 'undefined') {
    setTimeout(function(){
      $("footer").addClass("isSet")
    },500)

  }
  


